export default "__VITE_ASSET__f6507a0f__"